<template>
  <ModalContent 
    ref="redaction-history" 
    name="redaction-history"
    :title="$t('fields.redact_history')" 
    width="80%" 
    :maxWidth="1000"
    @cancel="handleCloseModal()" 
    @submit="handleCloseModal()"
    :submitButtonText="$t('actions.OK')">
    <template #content>
      <div class="container flex w-full flex-grow max-w-full overflow-y-auto scroll-bar">
        <div class="w-full">
          <div v-if="loading" class="text-center py-8">
            <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
          <div class="space-y- border border-solid border-gray-400" style="min-height: 200px">
            <div class="risk-grid grid grid-cols-3 gap-4 items-center bg-blue-50 px-4 pr-6 py-1 font-medium">
              <p class="col-span-1 text-center"> {{ $t('fields.redact_reason') }}</p>
              <p class="col-span-1 text-center"> {{ $t('fields.redacted_by') }} </p>
              <p class="col-span-1 text-center"> {{ $t('fields.redacted_date') }} </p>
            </div>

            <div v-for="(item, index) in historyData" :key="index" class="risk-grid grid grid-cols-3 gap-4 items-center bg-base-100 px-4 pr-6 py-1 font-medium"
              :class="index % 2 === 0 ? 'bg-base-200': ''">
              <p class="col-span-1 text-center"> {{ item.reason }}</p>
              <p class="col-span-1 text-center"> {{ item.user_name }} </p>
              <p class="col-span-1 text-center"> {{ formatDate(item.timestamp) }} </p>
            </div>

            <div v-if="historyData.length === 0" class="risk-grid grid grid-cols-3 gap-4 items-center bg-base-100 px-4 pr-6 py-1 font-medium">
              <p class="col-span-3 text-center">
                {{ $t('fields.no_redaction_history') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalContent>
</template>

<script>
import ModalContent from "@shared/modal-content";
import { formatUtcDate, DATETIME_FORMAT_5 } from "@shared/utils/dateTime";

export default {
  name: "redaction-history",
  components: {
    ModalContent
  },
  props: {
    entityId: {
      type: [String, Number],
      required: true
    },
    historyData: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handleCloseModal() {
        this.$refs['redaction-history'].hideModal();
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      return dateString ? formatUtcDate(dateString, { format: DATETIME_FORMAT_5 }) : '';
    }
  }
}
</script>